import { render, staticRenderFns } from "./shopFreightTemplateEdit.vue?vue&type=template&id=122c6ea0&"
import script from "./shopFreightTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./shopFreightTemplateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports